import { server$ } from "@builder.io/qwik-city";
import { EnvKey } from "~/lib/utils";
import {
  getSignedUrl as _getSignedUrl,
  getPublicUrl as _getPublicUrl,
} from "~/lib/image-helpers";

/**
 * Generates a signed URL for uploading a file to GCS.
 * @param filename - Original file name.
 * @param contentType - MIME type of the file.
 * @returns An object containing the signed URL and blob name.
 */
export const getSignedUrl = server$(async function (
  filename: string,
  contentType: string,
): Promise<{ signedUrl: string; blobName: string }> {
  return _getSignedUrl(
    filename,
    contentType,
    this.env.get(EnvKey.GOOGLE_APPLICATION_CREDENTIALS)!,
  );
});

/**
 * Constructs the public URL for a given blob name.
 * @param blobName - The name of the blob in GCS.
 * @returns The public URL of the image.
 */
export const getPublicUrl = server$(async function (
  blobName: string,
): Promise<string> {
  return _getPublicUrl(blobName);
});
